export default function PaginationEllipsis() {
  return (
    <li className="tw:flex tw:justify-center tw:items-center tw:gap-2">
      <span className="tw:h-2 tw:w-2 tw:rounded-full tw:bg-gray-400"></span>
      <span className="tw:h-2 tw:w-2 tw:rounded-full tw:bg-gray-400"></span>
      <span className="tw:h-2 tw:w-2 tw:rounded-full tw:bg-gray-400"></span>
    </li>
  )
}